module.exports = __webpack_public_path__ + "img/257.5c4c1606.jpg";